
import { FormControl, FormControlLabel, FormLabel, Radio, RadioGroup } from '@mui/material';
import { INTEGRATION_SYNC_DIRECTION } from '@weft/types';
import { validateEnum } from '@weft/utils';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { ConfigurationViewPropertiesBlock } from '../../ConfigurationViewPropertiesBlock';
import { NET_SUITE_CONFIGURATION_SECTIONS } from '../net-suite-configuration-consts/net-suite-configuration-sections';
import type { NetSuiteIntegrationConfigurationWithSections } from '../net-suite-configuration-types/net-suite-configuration-type';

export const SyncConfigurationSection: React.FC = () => {
  const { watch, resetField, setValue } = useFormContext<NetSuiteIntegrationConfigurationWithSections>();

  const currentSyncDirectionValue = watch('syncDirection');
  const isInEditMode = watch('sectionToEdit') === NET_SUITE_CONFIGURATION_SECTIONS.sync;

  const handleCancelClick = () => {
    resetField('syncDirection');
  };

  return (
    <ConfigurationViewPropertiesBlock<NetSuiteIntegrationConfigurationWithSections>
      title='Sync Settings'
      showEditButton
      onCancel={handleCancelClick}
      fieldValue={NET_SUITE_CONFIGURATION_SECTIONS.sync}
      field='sectionToEdit'
    >
      <FormControl disabled={!isInEditMode}>
        <FormLabel> Sync direction </FormLabel>
        <RadioGroup
          value={currentSyncDirectionValue}
          onChange={(_event, newOption) => {
            validateEnum(newOption, INTEGRATION_SYNC_DIRECTION);
            setValue('syncDirection', newOption);
            resetField('syncDirection');
          }}
        >
          <FormControlLabel
            value={INTEGRATION_SYNC_DIRECTION.from}
            control={<Radio />}
            label="Read"
          />
          <FormControlLabel
            value={INTEGRATION_SYNC_DIRECTION.to}
            control={<Radio />}
            label="Write"
          />
        </RadioGroup>
      </FormControl>
    </ConfigurationViewPropertiesBlock>
  );
};